import { Button } from "@shared/components";
import { ErrorPagesInfo } from "constants/error_pages";
import { PageProps, PageWithLayout } from "@types";
import Link from "next/link";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import IconFilledHome from "@svg/new-design/filled-hme";

// pages/400.js
interface Props extends PageProps {}

export const HomeLink = (
  <Link href="/" prefetch={false}>
    <Button startIcon={<IconFilledHome className="ml-1" />}>
      رفتن به صفحه اصلی
    </Button>
  </Link>
);

const ErrorPage400: PageWithLayout<Props> = () => {
  return (
    <div className="mt-16 w-full">
      <div className=" container-bs">
        <div className=" flex w-full flex-col items-center">
          <div className="mb-6 md:mb-5">
            <img
              src={ErrorPagesInfo[400].image}
              alt="400"
              className="h-[160px] lg:h-[270px] w-auto"
            />
          </div>
          <div>
            <h2 className="headline-sm md:headline-md text-center mb-2.5 text-fds-primary">
              {ErrorPagesInfo[400].title}
            </h2>
            <p className="body-md md:body-lg text-fds-secondary text-center max-w-[296px] md:max-w-[572px]">
              {ErrorPagesInfo[400].subtitle}
            </p>
          </div>
          <div className="mt-6">{HomeLink}</div>
        </div>
      </div>
    </div>
  );
};

ErrorPage400.getLayout = (page, props) =>
  getDefaultLayout(
    page,
    { ...props },
    {
      footerProps: {
        showAdsFooter: false,
        showAppFooter: false,
        showButtonOrganizationFooter: false,
        showHomeAppFooter: false,
        showLinkFooter: false,
        showMainFooter: false,
        showOrganizationFooter: false,
        showValuesFooter: false,
      },
    }
  );
export default ErrorPage400;
